import { colours } from '../../../styles/colours';

import { createStyles } from '@material-ui/core';

const styles = createStyles({
  container: {
    maxWidth: '350px',
    height: '200px',
    margin: '10px',
    padding: '5px',
    border: '1px solid grey',
    backgroundColor: '#e6e6e6',
    touchAction: 'none',
    display: 'inline-grid',
    gridTemplate: '1fr 3fr / 1fr 1fr',
    gridTemplateAreas: `'header clear' 'svgContainer svgContainer'`,
    alignItems: 'center'
  },

  header: {
    display: 'inline',
    gridArea: 'header',
    marginLeft: '5px'
  },

  clear: {
    gridArea: 'clear',
    justifySelf: 'end',
    marginRight: '5px'
  },

  error: {
    borderColor: colours.red500
  },

  warning: {
    borderColor: colours.orange300
  },

  '@media print': {
    container: {
      backgroundColor: 'white'
    }
  }
});

export default styles;
